/*
 *  Vanilla Javascript timepicker that allows setting of minTime and maxTime
 *
 *        View below code for a list of available methods
 *
 *  Developer: Lance Jernigan
 *  Version: 1.0.4
 *
 */


/*
 *  Setup our arguments to pass to our timepicker
 *
 *  @args - format (boolean) - Whether to format the input value or leave in 24 hour
 *          minTime (string) - Minimum time the timepicker should reach (any valid time string Javascript's Date() will accept)
 *          maxTime (string) - Maximum time the timepicker should reach (any valid time string Javascript's Date() will accept)
 *          meridiem (boolean) - Whether the timepicker should display the meridiem (defaults to true if format is true and false if format is false)
 *          arrowColor (string) - Any valid color (Hex, RGB, RGBA, etc.) to use for the arrows
 *
 */

const args = {
  format: true,
  minTime: '11:00 am',
  maxTime: '6:00 pm',
  meridiem: false,
  increment: 5,
};

/*
 *  Create a new timepicker for our input and pass it our args
 */

// var tpicker = new timepicker(document.querySelector('input.timepicker'), args)


/*
 *  Starts our Timepicker Functionality
 */


export default function timepicker(element, args) {
  this.initialized = false;
  this.element = null;
  this.elements = {};
  this.timepicker = null;

  const tempDate = new Date();
  const tempIncrement = Utils.isNotDefined(args.increment) ? 5 : args.increment;
  let tempMinutes = ((Math.ceil(tempDate.getMinutes() / tempIncrement) * tempIncrement) % 60);
  if (tempMinutes < 10) {
	    tempMinutes = `0${tempMinutes}`;
  }
  this.time = new Date(`${tempDate.toDateString()} ${(`${tempDate.getHours()}:${tempMinutes}:00`).trim()}`);

  this.settings = {
    format: true,
    meridiem: true,
    minTime: null,
    maxTime: null,
    increment: null,
  };
  this.active = false;

  this.roundToQuarterHour = function (date) {
    const hour = date.getHours();
    const minutes = date.getMinutes();
    const meridiem = hour >= 12 ? 'pm' : 'am';

    let newMinutes = (Math.ceil(minutes / this.settings.increment) * this.settings.increment) % 60;
    if (newMinutes < 10) {
      newMinutes = `0${newMinutes}`;
    }
    const newTime = new Date(`${new Date().toDateString()} ${(`${hour}:${newMinutes}:00`).trim()}`);

    return newTime;
  };

  this.getIEVersion = function () {
    const sAgent = window.navigator.userAgent;
    const Idx = sAgent.indexOf('MSIE');

    // If IE, return version number.
    if (Idx > 0) { return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx))); }

    // If IE 11 then look for Updated user agent string.
    if (navigator.userAgent.match(/Trident\/7\./)) { return 11; }

    return 0; // It is not IE
  };

  this.updateSettings = function (args) {
    args = args || {};

    for (let a = 0; a < Object.keys(args).length; a++) {
      this.settings[Object.keys(args)[a]] = args[Object.keys(args)[a]];
    }

    if (!this.settings.format && typeof args.meridiem === 'undefined') {
      this.settings.meridiem = false;
    }

    const is_safari = !!(navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1);
    const is_ie = this.getIEVersion();
    const is_edge = navigator.userAgent.indexOf('Edge') != -1;
    let is_ie11 = false;
    if (is_ie > 0) {
      if (is_ie == 11 || is_ie == 10) is_ie11 = true;
    }

    let maxString = ' 24:00';
    // don't ask me why but Safari and IE Edge handle midnight diferently. This fixes the bug.
    if (is_edge || is_ie11) {
      maxString = ' 00:00';
    } else if (is_safari) {
      maxString = ' -00:00';
    }


    this.settings.meridiem = this.settings.format ? true : this.settings.meridiem;
    this.settings.minTime = this.settings.minTime && !this.settings.minTime.hasOwnProperty('getDate') ? (new Date(`${new Date().toDateString()} ${this.settings.minTime}`)) : (new Date(`${new Date().toDateString()} 00:00`));
    this.settings.maxTime = this.settings.maxTime && !this.settings.maxTime.hasOwnProperty('getDate') ? (new Date(`${new Date().toDateString()} ${this.settings.maxTime}`)) : (new Date(new Date().toDateString() + maxString));
    this.settings.increment = isNaN(this.settings.increment) ? 5 : this.settings.increment;

    if (this.settings.maxTime.toString() == this.settings.minTime.toString()) {
      const maxTime = new Date(this.settings.minTime);

      maxTime.setHours(maxTime.getHours() + 24);

      this.settings.maxTime = maxTime;
    }

    if (this.element.value) {
      const newTime = this.roundToQuarterHour(new Date(`${new Date().toDateString()} ${this.element.value}`));

      this.time = !isNaN(newTime.getTime()) ? newTime : this.time;
    }

    this.time.setMilliseconds(0);

    if (Object.keys(this.elements).length) {
      this.updateTime('minute', true, 0);

      this.render();
    }

    if (!this.validateTime()) {
      this.time = this.settings.minTime ? this.settings.minTime : this.settings.maxTime;
    }
  };

  this.buildTimepicker = function () {
    const wrapper = document.createElement('div');
    const elements = ['hour', 'minute', 'meridiem'];

    wrapper.className = 'timepicker__wrapper';
    wrapper.setAttribute('id', `tp_${Math.floor(Math.random() * 100) + 1}`);

    if (!Object.keys(this.elements).length) {
      for (let e = 0; e < elements.length; e++) {
        this.elements[elements[e]] = document.createElement('div');
        this.elements[elements[e]].className = `timepicker__${elements[e]}`;

        const up = document.createElement('div');
        up.appendChild(document.createElement('div'));
        const display = document.createElement('p');
        const down = document.createElement('div');
        down.appendChild(document.createElement('div'));

        up.className = 'timepicker__button timepicker__button__up';
        display.className = 'display';
        down.className = 'timepicker__button timepicker__button__down';

        if (this.settings.arrowColor) {
          up.childNodes[0].style['border-bottom-color'] = this.settings.arrowColor;
          down.childNodes[0].style['border-top-color'] = this.settings.arrowColor;
        }

        this.elements[elements[e]].appendChild(up);
        this.elements[elements[e]].appendChild(display);
        this.elements[elements[e]].appendChild(down);
      }
    }

    this.timepicker = wrapper;

    this.element.parentNode.insertBefore(wrapper, this.element.nextSibling);

    this.addListeners();

    this.render();
  };

  this.render = function () {
    const wrapper = this.cleanWrapper(this.timepicker);

    if (this.settings.meridiem) {
      wrapper.className = wrapper.className.indexOf(' timepicker__wrapper-full') >= 0 ? wrapper.className : `${wrapper.className} timepicker__wrapper-full`;
    }

    for (let e = 0; e < Object.keys(this.elements).length; e++) {
      const key = Object.keys(this.elements)[e];
      const element = this.elements[key];
      const func = `get${key.charAt(0).toUpperCase()}${key.slice(1)}`;

      element.querySelector('.display').innerText = this[func]();

      if (Object.keys(this.elements)[e] == 'meridiem' && !this.settings.meridiem) {
        continue;
      }

      wrapper.appendChild(element);
    }

    this.timepicker = wrapper;

    this.updateInput();
  };

  this.cleanWrapper = function (wrapper) {
    while (wrapper.hasChildNodes()) {
      wrapper.removeChild(wrapper.lastChild);
    }

    return wrapper;
  };

  this.handleMinuteClick = function (e) {
     const element = e.currentTarget;

    const parent = element.parentNode.className.replace('timepicker__', '');
    const add = element.className.indexOf('up') !== -1;
    this.updateTime(parent, add, this.settings.increment);
  };

  this.handleClick = function (e) {
    const element = e.currentTarget;

    const parent = element.parentNode.className.replace('timepicker__', '');
    const add = element.className.indexOf('up') !== -1;

    this.updateTime(parent, add);
  };

  this.validateInput = function (e) {
    const { value } = e.currentTarget;
    let date = value.length ? this.roundToQuarterHour(new Date(`${new Date().toDateString()} ${value}`)) : false;
    if (date && !isNaN(date.getTime())) {
      this.time = date;
    }

    if (!this.validateTime()) {
      const after = date.getTime() > this.settings.maxTime.getTime();
      date = after ? this.roundToQuarterHour(new Date(this.settings.maxTime)) : this.roundToQuarterHour(new Date(this.settings.minTime));
      after ? date.setMinutes(date.getMinutes()) : date.setMinutes(date.getMinutes());

      this.time = date;
    }

    this.render();
  };

  this.updateTime = function (method, add, amount) {
    var amount = amount || 1;

    switch (method) {
      case 'meridiem':

        this.time.getHours() > 12 ? this.time.setHours(this.time.getHours() - 12) : this.time.setHours(this.time.getHours() + 12);

        break;

      default:

        if (add) {
          this.add(method, amount);
        } else {
          this.subtract(method, amount);
        }
    }

    if (!this.validateTime()) {
      const date = add ? (new Date(this.settings.minTime)) : (new Date(this.settings.maxTime));
      add ? date.setMinutes(date.getMinutes()) : date.setMinutes(date.getMinutes());

      this.time = date;
    }

    this.render();
  };

  this.add = function (method, amount) {
    var amount = amount || 1;

    switch (method) {
      case 'minute':

        this.time.setMinutes(this.time.getMinutes() + amount);

        break;

      case 'hour':

        this.time.setHours(this.time.getHours() + amount);

        break;
    }
  };

  this.subtract = function (method, amount) {
    var amount = amount || 1;

    switch (method) {
      case 'minute':

        this.time.setMinutes(this.time.getMinutes() - amount);

        break;

      case 'hour':

        this.time.setHours(this.time.getHours() - amount);

        break;
    }
  };

  this.validateTime = function () {
    if (this.settings.minTime) {
      this.settings.maxTime = this.settings.maxTime;

      this.time.setDate(this.roundToQuarterHour(new Date()).getDate());

      return this.time.getTime() < this.settings.maxTime.getTime() && this.time.getTime() > this.settings.minTime.getTime();
    }

    return true;
  };

  this.updateInput = function (parent) {
    if (!this.element.hasAttribute('readOnly')) {
      if (this.initialized) {
        const previousVal = this.element.value;
        const newVal = this.buildString();

        this.element.value = newVal;

        if (previousVal != newVal) {
          this.triggerOnChange(element);
        }
      }
    }
  };

  this.triggerOnChange = function (element) {
    if ('createEvent' in document) {
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', false, true);
      element.dispatchEvent(evt);
    } else { element.fireEvent('onchange'); }
  };

  this.buildString = function () {
    return (`${this.getHour()}:${this.getMinute()} ${this.getMeridiem()}`).trim();
  };

  this.toggleActive = function (e) {
    if (e.target == this.element) {
      if (!this.initialized) {
        this.initialized = true;

        this.updateInput();
      }

      this.updateBounds(this.timepicker, e.target);

      this.active = true;
    } else if (e.target && e.target.className && e.target.className.indexOf('timepicker__') == -1 && e.target.parentElement && e.target.parentElement.className.indexOf('timepicker__') == -1) {
      this.active = false;
    }
    if (!e.target.hasAttribute('readOnly')) {
      this.timepicker.className = this.active ? this.timepicker.className.indexOf(' timepicker__wrapper-active') >= 0 ? this.timepicker.className : `${this.timepicker.className} timepicker__wrapper-active` : this.timepicker.className.replace(' timepicker__wrapper-active', '');
    }
  };

  this.updateBounds = function () {
    const bounds = this.element.getBoundingClientRect();

    this.timepicker.style.top = `${this.element.offsetTop + this.element.innerHeight}px`;
    this.timepicker.style.width = `${bounds.width}px`;
  };

  this.addListeners = function () {
    const elements = Object.keys(this.elements);

    for (let e = 0; e < elements.length; e++) {
      const element = this.elements[elements[e]];
      const buttons = [].slice.call(element.childNodes).filter(node => node.className.indexOf('button') !== -1);

      for (let c = 0; c < buttons.length; c++) {
        const button = buttons[c];
        if (button.parentNode.classList.contains('timepicker__minute')) {
          button.addEventListener('click', this.handleMinuteClick.bind(this));
        } else {
                	button.addEventListener('click', this.handleClick.bind(this));
        }
      }
    }

    this.element.addEventListener('change', this.validateInput.bind(this));
    document.body.addEventListener('click', this.toggleActive.bind(this));
    window.addEventListener('resize', this.updateBounds.bind(this));
  };

  this.getTime = function () {
    return this.time;
  };

  this.getHour = function () {
    if (!this.settings.format) {
      return this.time.getHours() < 10 ? `0${this.time.getHours()}` : this.time.getHours();
    }

    return this.time.getHours() > 12 ? this.time.getHours() % 12 : this.time.getHours() == 0 ? 12 : this.time.getHours();
  };

  this.getMinute = function () {
    const minutes = this.time.getMinutes();

    return minutes < 10 ? `0${minutes}` : minutes;
  };

  this.getMeridiem = function () {
    if (!this.settings.meridiem) {
      return '';
    }

    return this.time.getHours() >= 12 ? 'pm' : 'am';
  };

  this.init = function () {
    if (element.length) {
      console.warn('Timepicker selector must be for a specific element, not a list of elements.');

      return;
    }

    this.element = element;

    this.updateSettings(args);
    this.buildTimepicker();
  };

  this.init();
}

/*
 *  Timepicker Methods
 *
 *  updateSettings()
 *
 *     Update the settings originally passed to your timepicker
 *
 *     @parameters - args (a list of available arguments is provided above the code)
 *
 *
 *  updateTime()
 *
 *     Update the time based on parameters passed
 *
 *     @parameters - method (string) - What method to affect ('hour', 'minute', 'meridiem')
 *                   add (boolean) - True to add amount, false to subtract amount
 *                   amount /optional/ (number) - Number to add or subtract from method (defaults to 1)
 *
 *
 *  add()
 *
 *     Add amount to selected method
 *
 *     @parameters - method (string) - What method to affect ('hour', 'minute')
 *                   amount /optional/ (number) - Number to add to method (defaults to 1)
 *
 *
 *  subtract()
 *
 *     subtract amount from selected method
 *
 *     @parameters - method (string) - What method to affect ('hour', 'minute')
 *                   amount /optional/ (number) - Number to subtract from method (defaults to 1)
 *
 *
 *  buildString()
 *
 *     Returns the string that will be sent to the input
 *
 *
 *  getTime()
 *
 *     Returns the date object for the current selected time
 *
 *
 *  getHour()
 *
 *     Returns the current hour for the timepicker
 *
 *
 *  getMinute()
 *
 *     Returns the current Minute for the timepicker
 *
 *
 *  getMeridiem()
 *
 *     Returns the current Meridiem for the timepicker
 *
 *
 *  get
 */
